import { useEffect } from 'react';
import { useMasterData } from '../context/MasterDataContext';
import { useGuru } from '../context/GuruContext';
import { useAuth } from './useAuth';

/**
 * Hook ini bertugas memastikan data master yang bersifat statis atau semi-statis
 * (Tahun Ajaran, Kelas, Asrama, Murobbi, Ekskul, Halaqoh, Guru) selalu tersedia
 * di dalam global state (context) bagi komponen yang membutuhkannya, tanpa harus
 * di-fetch berulang kali atau di-eager-load secara brutal saat login awal (yang memperlambat UI).
 *
 * Data berat seperti 'Santri' tidak dimasukkan ke sini dan harus tetap di-fetch
 * secara lazy/paginated oleh komponen spesifik yang membutuhkannya.
 */
export const useMasterDataAutoFetch = () => {
    const { authUser } = useAuth();
    const {
        tahunAjaranRecords, fetchTahunAjaranData,
        kelasRecords, fetchKelasData,
        asramaRecords, fetchAsramaData,
        murobbiRecords, fetchMurobbiData,
        halaqohRecords, fetchHalaqohData,
        ekskulRecords, fetchEkskulData
    } = useMasterData();

    const { guruRecords, fetchGuruData } = useGuru();

    useEffect(() => {
        // Hanya memicu fetch jika user sudah login
        if (!authUser) return;

        // Fetch secara lazy (fungsi-fungsi ini sudah memiliki pengecekan in-memory cache di dalamnya
        // sehingga sangat aman dipanggil berulang kali, mereka hanya akan mem-fetch ke Firestore
        // jika data di cache lokal benar-benar kosong).

        if (tahunAjaranRecords.length === 0) fetchTahunAjaranData();
        if (kelasRecords.length === 0) fetchKelasData();
        if (asramaRecords.length === 0) fetchAsramaData();
        if (murobbiRecords.length === 0) fetchMurobbiData();
        if (halaqohRecords.length === 0) fetchHalaqohData();
        if (ekskulRecords.length === 0) fetchEkskulData();
        if (guruRecords.length === 0 && fetchGuruData) fetchGuruData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authUser, tahunAjaranRecords.length, kelasRecords.length, asramaRecords.length, murobbiRecords.length, halaqohRecords.length, ekskulRecords.length, guruRecords.length]);

    return true; // Indicate that hook is mounted
};
